import {
  faArchive,
  faBan,
  faMapMarker,
  faMapMarkerAlt,
  faAtom,
  faBriefcase,
  faFileAlt,
  faCode,
  faDownload,
  faUser,
  faUsers,
  faPencilAlt,
  faArrowCircleUp,
  faList,
  faTachometerAlt,
  faCaretDown,
  faFilter,
  faArrowUp,
  faArrowDown,
  faTimesCircle,
  faEllipsisV,
  faEllipsisH,
  faPlus,
  faMinus,
  faCheck,
  faCheckDouble,
  faQuestion,
  faTimes,
  faGamepad,
  faGift,
  faMoneyBillAlt,
  faExchangeAlt,
  faShieldAlt,
  faBell,
  faEnvelope,
  faEnvelopeOpen,
  faSearch,
  faSave,
  faTrashAlt,
  faShare,
  faShareAlt,
  faShareSquare,
  faDesktop,
  faChartArea,
  faChartPie,
  faSign,
  faPaintBrush,
  faUserCircle,
  faHandshake,
  faLink,
  faPlug,
  faEye,
  faEyeSlash,
  faLock,
  faInbox,
  faUserPlus,
  faUserCheck,
  faBars,
  faAward,
  faBicycle,
  faBalanceScale,
  faBolt,
  faBullhorn,
  faBullseye,
  faBrush,
  faChalkboard,
  faChessKnight,
  faCity,
  faClipboard,
  faCocktail,
  faDollarSign,
  faFlag,
  faGlasses,
  faGrin,
  faHeart,
  faHome,
  faIndustry,
  faInfinity,
  faLightbulb,
  faMagic,
  faRocket,
  faTree,
  faUniversity,
  faVideo,
  faVolumeDown,
  faWineGlass,
  faRobot,
  faPoundSign,
  faPlane,
  faPaperPlane,
  faPercent,
  faPhone,
  faMobile,
  faMugHot,
  faMountain,
  faCloudUploadAlt,
  faInfoCircle,
  faFileImport,
  faTh,
  faCog,
  faAddressCard,
  faHandHolding,
  faHandLizard,
  faComments,
  faBookmark,
  faSync,
  faHandHoldingHeart,
  faUserTie,
  faSignInAlt,
  faFileExport,
  faGhost,
  faMobileAlt,
  faTabletAlt,
  faTv,
  faBold,
  faItalic,
  faStrikethrough,
  faUnderline,
  faParagraph,
  faListUl,
  faListOl,
  faUndo,
  faRedo,
  faAlignCenter,
  faAlignRight,
  faAlignLeft,
  faImage,
  faChevronUp,
  faChevronDown,
  faSignOutAlt,
  faBuilding,
  faUserEdit,
  faEdit,
  faTag,
  faTags,
  faTrash,
  faHashtag,
  faExternalLinkAlt,
  faChartLine,
  faSignal,
  faClock,
  faPencilRuler,
  faLongArrowAltRight,
  faMoneyBillWave,
  faShoppingBag,
  faStore,
  faGem,
  faChalkboardTeacher,
  faListAlt,
  faUserShield,
  faGlobe,
  faPlay,
  faPlayCircle,
  faCalendar,
  faChevronRight,
  faChevronLeft,
  faNewspaper,
  faFont,
  faFileUpload,
  faTrophy,
  faMedal,
  faGraduationCap
} from '@fortawesome/free-solid-svg-icons';

import {
  faLinkedin,
  faLinkedinIn,
  faTwitter,
  faFacebook,
  faFacebookF,
  faWhatsapp,
  faWhatsappSquare,
  faWindows,
  faGoogle,
  faSlack,
  faAmazon,
  faFacebookMessenger,
  faAndroid,
  faInternetExplorer,
  faOpera,
  faBlackberry,
  faChrome,
  faEdge,
  faFirefox,
  faSafari,
  faApple,
  faLinux,
  faPlaystation,
  faXing,
} from '@fortawesome/free-brands-svg-icons';

export const faSolid = [
  // free-solid-svg-icons
  faArchive,
  faBan,
  faMapMarker,
  faMapMarkerAlt,
  faInfoCircle,
  faFileImport,
  faAtom,
  faBriefcase,
  faFileAlt,
  faUser,
  faCode,
  faDownload,
  faUsers,
  faPencilAlt,
  faGamepad,
  faGift,
  faArrowCircleUp,
  faList,
  faTachometerAlt,
  faCaretDown,
  faFilter,
  faArrowUp,
  faArrowDown,
  faTimesCircle,
  faEllipsisV,
  faEllipsisH,
  faPlus,
  faMinus,
  faCheck,
  faCheckDouble,
  faQuestion,
  faTimes,
  faMoneyBillAlt,
  faExchangeAlt,
  faShieldAlt,
  faBell,
  faEnvelope,
  faEnvelopeOpen,
  faSearch,
  faSave,
  faTrashAlt,
  faShare,
  faShareAlt,
  faShareSquare,
  faDesktop,
  faChartArea,
  faChartPie,
  faSign,
  faPaintBrush,
  faUserCircle,
  faHandshake,
  faLink,
  faPlug,
  faEye,
  faLock,
  faInbox,
  faUserPlus,
  faUserCheck,
  faBars,
  faCloudUploadAlt,
  faEyeSlash,
  faTh,
  faCog,
  faAddressCard,
  faHandHolding,
  faHandLizard,
  faComments,
  faBookmark,
  faSync,
  faHandHoldingHeart,
  faUserTie,
  faSignInAlt,
  faFileExport,
  faGhost,
  faMobileAlt,
  faTabletAlt,
  faTv,
  faBold,
  faItalic,
  faStrikethrough,
  faUnderline,
  faParagraph,
  faGraduationCap,
  faListUl,
  faListOl,
  faUndo,
  faRedo,
  faAlignCenter,
  faAlignRight,
  faAlignLeft,
  faImage,
  faChevronUp,
  faChevronDown,
  faSignOutAlt,
  faBuilding,
  faUserEdit,
  faEdit,
  faMobileAlt,
  faTabletAlt,
  faTv,
  faTag,
  faTags,
  faTrash,
  faHashtag,
  faExternalLinkAlt,
  faChartLine,
  faSignal,
  faClock,
  faPencilRuler,
  faLongArrowAltRight,
  faMoneyBillWave,
  faShoppingBag,
  faStore,
  faGem,
  faChalkboardTeacher,
  faListAlt,
  faUserShield,
  faGlobe,
  faPlay,
  faPlayCircle,
  faCalendar,
  faChevronRight,
  faChevronLeft,
  faNewspaper,
  faFont,
  faFileUpload,
  faTrophy,
  faMedal,
];

export const faBrands = [
  // free-brands-svg-icons
  faLinkedin,
  faLinkedinIn,
  faTwitter,
  faFacebook,
  faFacebookF,
  faWhatsapp,
  faWhatsappSquare,
  faWindows,
  faGoogle,
  faAmazon,
  faFacebookMessenger,
  faAndroid,
  faInternetExplorer,
  faOpera,
  faBlackberry,
  faChrome,
  faEdge,
  faFirefox,
  faSafari,
  faApple,
  faLinux,
  faPlaystation,
  faSlack,
  faXing,
];

export const departmentIcons = [
  faHandshake,
  faEye,
  faLock,
  faUserPlus,
  faChartArea,
  faSign,
  faBriefcase,
  faAtom,
  faDesktop,
  faAward,
  faBicycle,
  faBalanceScale,
  faBolt,
  faBullhorn,
  faBullseye,
  faBrush,
  faChalkboard,
  faChessKnight,
  faCity,
  faClipboard,
  faCocktail,
  faDollarSign,
  faFlag,
  faGlasses,
  faGrin,
  faHeart,
  faHome,
  faIndustry,
  faInfinity,
  faLightbulb,
  faMagic,
  faRocket,
  faTree,
  faUniversity,
  faVideo,
  faVolumeDown,
  faWineGlass,
  faRobot,
  faPoundSign,
  faPlane,
  faPaperPlane,
  faPercent,
  faPhone,
  faMobile,
  faMugHot,
  faMountain,
  faUsers,
  faBan,
  faTag,
  faPencilRuler,
  faLongArrowAltRight,
  faMoneyBillWave,
];

export const leaderboardScoreIcons = [
  faPlug,
  faLink,
  faFileAlt,
  faUsers,
  faHandshake,
];



// WEBPACK FOOTER //
// ./src/fontAwesome.js